<template>
  <div
    v-if="$store.state.isShowWheelSpinEvent"
    style="width: 100%; height: 100dvh; position: absolute; z-index: 1000"
  >
    <div
      class="flex items-center"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.5);
      "
    >
      <div
        style="
          width: 6.9rem;
          height: 78dvh;
          background-color: #072e25;
          border-radius: 0.2rem;
          border: 1px solid #2e9368;
          padding: 0.2rem 0;
          margin-top: 1rem;
        "
      >
        <div
          style="padding: 0 0.2rem 0.2rem 0.2rem"
          class="flex justify-between items-center"
        >
          <div
            class="flex items-center"
            style="
              width: 100%;
              border-radius: 0.2rem;
              border: 1px solid #2e9368;
              padding: 0.05rem 0.2rem 0.05rem 0.1rem;
            "
          >
            <svg-icon
              slot="left-icon"
              style="width: 0.3rem; height: 0.3rem; color: #fff"
              classNameQita
              icon-class="icon-draw-voice"
            />
            <div>
              <van-swipe
                vertical
                class="notice-swipe"
                :autoplay="5000"
                :show-indicators="false"
              >
                <van-swipe-item v-for="item in winningRecord"
                  ><div
                    style="font-size: 0.22rem; color: #fff; margin-left: 0.1rem"
                  >
                    <span>ID:{{ item.userid }} ganhou o prêmio</span>
                    <span style="color: #fedf58; margin-left: 0.1rem">{{
                      item.money
                    }}</span>
                  </div></van-swipe-item
                >
                <van-swipe-item
                  ><div
                    style="font-size: 0.22rem; color: #fff; margin-left: 0.1rem"
                  >
                    <span>ID:5669***4596 ganhou o prêmio</span>
                    <span style="color: #fedf58; margin-left: 0.1rem"
                      >54,51</span
                    >
                  </div></van-swipe-item
                >
              </van-swipe>
            </div>
          </div>
          <div
            class="flex justify-between items-center"
            style="padding-left: 0.1rem; height: 0.38rem"
          >
            <div
              class="flex items-center"
              style="width: 0.38rem; height: 0.38rem"
              @click="showInstructions = true"
            >
              <svg-icon
                slot="left-icon"
                style="
                  width: 0.38rem;
                  height: 0.38rem;
                  color: #fedf58;
                  cursor: pointer;
                "
                classNameQita
                icon-class="icon-draw-qa"
              />
            </div>
            <div
              class="flex items-center"
              style="width: 0.38rem; height: 0.38rem; margin-left: 0.2rem"
              @click="
                $router.push({ name: 'records' }),
                  ($store.state.isShowWheelSpinEvent = false)
              "
            >
              <svg-icon
                slot="left-icon"
                style="
                  width: 0.38rem;
                  height: 0.38rem;
                  color: #fedf58;
                  cursor: pointer;
                "
                classNameQita
                icon-class="icon-draw-histroy"
              />
            </div>
          </div>
        </div>
        <div class="draw-mainbox">
          <div
            class="flex justify-center items-center"
            style="flex-direction: column; color: #fedf58"
          >
            <div class="flex justify-center items-center">
              <svg-icon
                slot="left-icon"
                style="width: 0.42rem; height: 0.42rem"
                classNameQita
                icon-class="icon-draw-money-icon"
              />
              <span
                style="
                  margin-left: 0.1rem;
                  font-size: 0.48rem;
                  line-height: 0.72rem;
                  font-weight: 700;
                "
                >{{ formatCurrency(String(bonusMoney)) }}</span
              >
            </div>
            <div
              style="
                margin-top: 0.1rem;
                border-radius: 0.1rem;
                font-size: 0.2rem;
                border: unset;
                background: linear-gradient(180deg, #ffffa8 0%, #e2e231 100%);
                color: #005729;
                font-weight: 400;
                line-height: 0.48rem;
                height: 0.48rem;
                width: 1.18rem;
                text-align: center;
                cursor: pointer;
              "
              @click="receber"
            >
              Receber
            </div>
          </div>
          <div class="temu-panel">
            <div class="temu-box">
              <div
                class="turntable-main turntable-main1"
                :style="{ transform: `rotate(${rotate}deg)` }"
                style="
                  background-repeat: no-repeat;
                  background-position: center;
                "
              >
                <div
                  class="turntable-main-item"
                  :style="{ transform: `rotate(${60 * index}deg)` }"
                  v-for="(item, index) in register_prize"
                  :key="index"
                >
                  <div
                    class="flex justify-center items-center"
                    style="flex-direction: column"
                  >
                    <div
                      class="flex justify-center items-center"
                      style="
                        margin-top: 0.05rem;
                        width: inherit;
                        height: 0.56rem;
                        font-size: 0.22rem;
                        font-weight: 700;
                        line-height: 0.22rem;
                        word-break: break-all;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        color: #005729;
                      "
                    >
                      {{ item.name }}
                    </div>
                    <img
                      :src="item.icon"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                </div>
              </div>
              <div
                class="turntable-main turntable-main2"
                :style="{ opacity: showTemuOut ? 1 : 0 }"
              ></div>
              <div
                class="turntable-main turntable-main3"
                :style="{ opacity: showTemuOut ? 0 : 1 }"
              ></div>
              <div
                class="point"
                :style="{
                  cursor: bonusMoney >= 100 ? 'no-drop' : ''
                }"
                @click="handleStart"
              >
                <img
                  v-if="lotteryChances > 0"
                  class="box-hand"
                  src="../assets/icons/images/draw-hand.png"
                  alt=""
                  style="
                    width: 0.84rem;
                    position: absolute;
                    bottom: -0.25rem;
                    right: 0.3rem;
                    z-index: 3;
                  "
                />
                <div
                  v-if="!bonusLoading"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    width: 1.2rem;
                    color: #fff;
                    /* margin: 0.15rem 0.15rem 0.15rem 0.12rem; */
                  "
                  :style="{
                    cursor: lotteryChances == 0 ? 'no-drop' : 'pointer'
                  }"
                >
                  <div
                    class="flex justify-center items-center"
                    style="font-weight: 700; font-size: 0.3rem"
                  >
                    x
                    <span
                      style="
                        font-weight: 700;
                        font-size: 0.44rem;
                        margin-left: 0.05rem;
                      "
                    >
                      {{ lotteryChances }}
                    </span>
                  </div>
                  <span style="font-size: 0.22rem">Sorteio grátis</span>
                </div>
                <div
                  v-else
                  style="
                    text-align: center;
                    width: 1rem;
                    height: 0.5rem;
                    color: #fedf58;
                    margin: 0.15rem 0.15rem 0.15rem 0.12rem;
                    font-weight: 700;
                    font-size: 0.44rem;
                    overflow: hidden;
                  "
                >
                  <div
                    style="text-align: center; height: 0.5rem"
                    class="flex justify-center items-center numchange"
                  >
                    0,00
                  </div>
                  <div
                    style="text-align: center; height: 0.5rem"
                    class="flex justify-center items-center numchange2"
                  >
                    {{ temu_bonusMoney }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              width: 100%;
              margin-top: 0.2rem;
              display: flex;
              align-items: center;
              font-size: 0.22rem;
              color: #fedf58;
            "
            :style="{ justifyContent: userInfo?.id ? 'space-between' : 'end' }"
          >
            <div
              v-if="userInfo?.id"
              class="flex items-center"
              style="color: #fff"
            >
              Código de Convite {{ userInfo.id }}
              <div style="margin: 0 0.1rem" @click="copyContent(userInfo.id)">
                <svg-icon
                  style="
                    cursor: pointer;
                    width: 0.24rem;
                    height: 0.24rem;
                    color: #fedf58;
                  "
                  icon-class="comm_icon_copy--svgSprite:all"
                />
              </div>
            </div>
            <div style="cursor: pointer" @click="showRecordBox">
              Os meus subordinados
            </div>
          </div>
          <div
            style="
              border-radius: 0.1rem;
              font-size: 0.24rem;
              border: unset;
              background: linear-gradient(180deg, #ffffa8 0%, #e2e231 100%);
              color: #005729;
              font-weight: 400;
              line-height: 0.74rem;
              width: 4.18rem;
              height: 0.74rem;
              text-align: center;
              cursor: pointer;
              margin: 0.2rem auto;
              position: relative;
            "
            @click="isShowShare = true"
          >
            Convidar amigos, Bônus de vitória
            <img
              v-if="lotteryChances == 0"
              class="box-hand"
              src="../assets/icons/images/draw-hand.png"
              alt=""
              style="
                width: 0.84rem;
                position: absolute;
                top: 0.5rem;
                right: 0;
                z-index: 3;
              "
            />
          </div>
          <div
            style="
              line-height: 1.45;
              font-size: 0.22rem;
              width: calc(100% - 0.4rem);
              background-color: #16543a;
              padding: 0.1rem 0.2rem 0.2rem;
              border-radius: 0.2rem;
              color: #fff;
            "
          >
            <div
              class="flex justify-center items-center"
              style="
                font-size: 0.24rem;
                line-height: 1.5;
                text-align: center;
                font-weight: 700;
              "
            >
              <svg-icon
                slot="left-icon"
                style="width: 0.6rem; height: 0.6rem"
                classNameQita
                icon-class="icon-draw-title"
              />
              <span style="margin: 0 0.2rem"
                >Conclua tarefas para ganhar giros grátis</span
              >
              <svg-icon
                slot="left-icon"
                style="
                  width: 0.6rem;
                  height: 0.6rem;
                  transform: rotate(-180deg);
                "
                classNameQita
                icon-class="icon-draw-title"
              />
            </div>
            <div class="box-item">
              <img
                style="width: 0.48rem; height: 0.48rem"
                src="../assets/icons/images/box-item-icon1.png"
                alt=""
              />
              <div>
                <span>3 horas online por dia</span>
                <img
                  style="
                    width: 0.28rem;
                    height: 0.28rem;
                    position: relative;
                    top: -0.03rem;
                    margin: 0px 0.08rem;
                  "
                  src="../assets/icons/images/box-item-icon4.png"
                  alt=""
                />
                <span style="color: #fedf58">＋1 Vezes</span>
              </div>
              <div
                style="
                  width: 1.2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                "
              >
                <div v-if="!mission.online">
                  <van-count-down
                    style="color: #fff; font-size: 0.2rem"
                    :time="3 * 60 * 60 * 1000"
                    @finish="signInPDD"
                  />
                  <div
                    v-if="userInfo?.id"
                    style="color: #809f92; font-size: 0.2rem"
                  >
                    para obter
                  </div>
                  <div
                    v-else
                    style="
                      color: #809f92;
                      font-size: 0.2rem;
                      text-align: center;
                      display: -webkit-box;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      vertical-align: middle;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                    "
                  >
                    Você poderá obtê-lo mais tarde.
                  </div>
                </div>
                <div
                  v-else
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #04be02;
                    width: 0.4rem;
                    height: 0.4rem;
                    border-radius: 50%;
                  "
                >
                  <svg-icon
                    slot="left-icon"
                    style="width: 0.22rem; height: 0.22rem; cursor: pointer"
                    classNameQita
                    icon-class="icon-draw-right"
                  />
                </div>
              </div>
            </div>
            <div class="box-item" style="margin-top: 0.1rem">
              <img
                style="width: 0.48rem; height: 0.48rem"
                src="../assets/icons/images/box-item-icon2.png"
                alt=""
              />
              <div style="width: 3.72rem">
                <div>
                  <span>Login diário</span>
                  <img
                    style="
                      width: 0.28rem;
                      height: 0.28rem;
                      position: relative;
                      top: -0.03rem;
                      margin: 0px 0.08rem;
                    "
                    src="../assets/icons/images/box-item-icon4.png"
                    alt=""
                  />
                  <span style="color: #fedf58">＋1 Vezes</span>
                </div>
                <div
                  style="
                    color: #809f92;
                    font-size: 0.2rem;
                    display: flex;
                    align-items: center;
                  "
                >
                  <span>Sorteio grátis:</span>
                  <van-count-down
                    style="color: #809f92; font-size: 0.2rem"
                    :time="countdown"
                  />
                </div>
              </div>
              <div
                style="
                  width: 1.2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #04be02;
                    width: 0.4rem;
                    height: 0.4rem;
                    border-radius: 50%;
                  "
                >
                  <svg-icon
                    slot="left-icon"
                    style="width: 0.22rem; height: 0.22rem; cursor: pointer"
                    classNameQita
                    icon-class="icon-draw-right"
                  />
                </div>
              </div>
            </div>
            <div class="box-item" style="margin-top: 0.1rem">
              <img
                style="width: 0.48rem; height: 0.48rem"
                src="../assets/icons/images/box-item-icon3.png"
                alt=""
              />
              <div style="width: 3.72rem">
                <div
                  style="align-items: center; display: flex; max-width: 3.72rem"
                >
                  <span
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    >Cada encaminhamento eficaz 0 pessoas</span
                  >
                  <span
                    style="
                      color: #fedf58;
                      display: flex;
                      align-items: center;
                      flex-shrink: 0;
                    "
                  >
                    <img
                      style="
                        width: 0.28rem;
                        height: 0.28rem;
                        position: relative;
                        top: -0.03rem;
                        margin: 0px 0.08rem;
                      "
                      src="../assets/icons/images/box-item-icon4.png"
                      alt=""
                    />
                    <span>＋1 Vezes</span></span
                  >
                </div>
                <div
                  style="
                    color: #809f92;
                    font-size: 0.2rem;
                    display: flex;
                    align-items: center;
                  "
                >
                  <span
                    v-if="userInfo?.id"
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    >Recarga subordinada ≥
                    {{ formatCurrency(String(invite_rule.recharge)) }} ...
                  </span>
                  <span
                    v-else
                    style="
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    "
                    >Faça login com sucesso durante o ciclo</span
                  >
                  <span
                    style="color: #fedf58; margin: 0 0.04rem"
                    @click="showRecordBox"
                    >Detalhes</span
                  >
                </div>
              </div>
              <div
                style="
                  width: 1.14rem;
                  height: 0.5rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: #fedf58;
                  color: #005729;
                  font-size: 0.2rem;
                  border-radius: 0.1rem;
                  padding: 0px 0.03rem;
                  cursor: pointer;
                "
                @click="isShowShare = true"
              >
                Convidar
              </div>
            </div>
          </div>
          <div
            class="my-records"
            style="
              line-height: 1.45;
              font-size: 0.22rem;
              width: calc(100% - 0.4rem);
              background-color: #16543a;
              padding: 0.1rem 0.2rem 0.2rem;
              border-radius: 0.2rem;
              color: #fff;
              margin-top: 0.2rem;
            "
          >
            <div
              class="flex justify-center items-center"
              style="
                font-size: 0.24rem;
                line-height: 1.5;
                text-align: center;
                font-weight: 700;
              "
            >
              <svg-icon
                slot="left-icon"
                style="width: 0.6rem; height: 0.6rem"
                classNameQita
                icon-class="icon-draw-title"
              />
              <span style="margin: 0 0.2rem">Meus Registros</span>
              <svg-icon
                slot="left-icon"
                style="
                  width: 0.6rem;
                  height: 0.6rem;
                  transform: rotate(-180deg);
                "
                classNameQita
                icon-class="icon-draw-title"
              />
            </div>
            <div v-for="item in records" class="my-records-item">
              <div style="color: #809f92; width: 2.3rem; text-align: left">
                {{ item.time }}
              </div>
              <div style="width: calc(100% - 2.3rem); height: 0.4rem">
                <div class="my-records-item-info">
                  {{ item.desc }}
                  <span v-if="item.bonus > 0" style="color: #fedf58">
                    {{ formatCurrency(String(item.bonus)) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex justify-center items-center"
        style="
          width: 0.65rem;
          height: 0.65rem;
          position: absolute;
          bottom: 0.6rem;
        "
        @click="closeBox"
      >
        <img
          style="width: 0.65rem; height: 0.65rem"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
    </div>
    <div
      v-show="
        isShowShare ||
        showRecord ||
        showReceber ||
        showBonus ||
        showInstructions
      "
      class="flex justify-center items-center"
      style="
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        position: relative;
        z-index: 1000;
      "
    >
      <div
        v-if="showInstructions"
        class="flex justify-center items-center"
        style="
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          z-index: 2000;
        "
      >
        <div
          style="
            width: 6.9rem;
            height: 85dvh;
            color: #fff;
            background-color: #072e25;
            border-radius: 0.2rem;
            border: 1px solid #fedf58;
            position: absolute;
            top: 5%;
          "
        >
          <div
            style="
              text-align: center;
              font-size: 0.32rem;
              height: 0.9rem;
              line-height: 0.9rem;
              padding: 0 0.2rem;
            "
          >
            Regras do Evento
          </div>
          <div
            style="
              padding: 0.2rem;
              font-size: 0.26rem;
              line-height: 0.42rem;
              white-space: pre-wrap;
              word-break: break-word;
            "
          >
            <div>
              <div>
                <div class="instructions-title">
                  <span
                    style="
                      height: 0.56rem;
                      line-height: 0.56rem;
                      position: relative;
                      display: inline-block;
                      max-width: 100%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      padding-left: 0.28rem;
                      padding-right: 0.1rem;
                      font-size: 0.32rem;
                      height: 0.56rem;
                      line-height: 0.56rem;
                      color: #005729;
                      background-color: #fedf58;
                      border-top-left-radius: 0.06rem;
                      z-index: 1;
                    "
                    ><span style="position: relative; padding-left: 0.4rem"
                      ><img
                        style="
                          width: 0.32rem;
                          height: 0.32rem;
                          vertical-align: text-top;
                          position: absolute;
                          left: 0;
                          top: 0;
                        "
                        src="../assets/icons/images/gif_icon.png"
                      />Descrição da atividade</span
                    ></span
                  ><i class="arrow_right"></i>
                </div>
              </div>
              <div class="">
                1. Durante o evento, ao concluir a tarefa especificada, você
                receberá giros grátis. Complete a barra de progresso para
                receber um bônus de 100,00, que poderá ser solicitado para saque
                direto para sua conta;<br />2. Faça login na página do evento
                todos os dias e receba 1 sorteio; O tempo online diário 3 Hora
                lhe dará 1 oportunidade de sorteio;<br />3. Você pode participar
                da tarefa para obter o número de sorteios, Para cada 2
                subordinados efetivamente promovidos, será dado 1 sorteio como
                brinde;<br />4. Você precisa usar seus giros existentes antes de
                poder continuar a receber novos giros, os giros não são
                cumulativos.<br />5. O bônus total obtido só pode ser coletado
                manualmente no lado iOS_APP, Android_APP、 PC、 iOS_H5,
                Android_H5, Se a recompensa não for resgatada dentro de 1 dias,
                a recompensa será distribuída automaticamente para a conta;<br />6.
                O bônus concedido neste evento requer 1 tempos de apostas
                efetivas antes de poder ser sacado, a aposta é Não limitado a
                plataformas de jogos.
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex justify-center items-center"
          style="
            width: 0.65rem;
            height: 0.65rem;
            position: absolute;
            bottom: 3dvh;
          "
          @click="showInstructions = false"
        >
          <img
            style="width: 0.65rem; height: 0.65rem"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
            alt=""
          />
        </div>
      </div>
      <div
        v-if="showDetails"
        class="flex justify-center items-center"
        style="
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          z-index: 2000;
        "
      >
        <div
          style="
            width: 6.5rem;
            height: 20dvh;
            color: #fff;
            background-color: #072e25;
            border-radius: 0.2rem;
            border: 1px solid #2e9368;
            padding: 0.2rem;
            position: absolute;
          "
        >
          <div
            style="
              text-align: center;
              padding-bottom: 0.2rem;
              font-size: 0.3rem;
            "
          >
            Detalhes
          </div>
          <div style="color: #809f92; font-size: 0.25rem">
            <div style="padding: 0.05rem">
              <span>Nome de Usuário:</span>
              <span style="color: #fff; margin-left: 0.1rem">{{
                details.user_name
              }}</span>
            </div>
            <div style="padding: 0.05rem">
              <span>Hora de registro:</span>
              <span style="color: #fff; margin-left: 0.1rem">{{
                details.reg_time
              }}</span>
            </div>
            <div style="padding: 0.05rem">
              <span>Válido ou não:</span>
              <span style="color: #fff; margin-left: 0.1rem"
                ><span
                  :style="{ color: details.valid == 1 ? '#04be02' : 'red' }"
                  >{{ details.valid == 1 ? 'Válido' : 'Inválido' }}</span
                ></span
              >
            </div>
            <div style="padding: 0.05rem">
              <span>Detalhes:</span>
              <span
                style="margin-left: 0.1rem"
                :style="{
                  color:
                    details.recharge_total >= invite_rule.recharge ? '#04be02' : '#fff'
                }"
                >1、Recarga cumulativa durante o ciclo
                {{ formatCurrency(details.recharge_total >= invite_rule.recharge ? invite_rule.recharge : details.recharge_total) }}</span
              >
              <br />
              <span
                :style="{
                  color:
                    details.bet_total >= invite_rule.bet ? '#04be02' : '#fff'
                }"
                >2、Codificacao cumulativa no ciclo
                {{ formatCurrency(details.bet_total >= invite_rule.bet ? invite_rule.bet : details.bet_total) }}</span
              >
            </div>
          </div>
        </div>
        <div
          class="flex justify-center items-center"
          style="
            width: 0.65rem;
            height: 0.65rem;
            position: absolute;
            bottom: 32dvh;
          "
          @click="showDetails = false"
        >
          <img
            style="width: 0.65rem; height: 0.65rem"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
            alt=""
          />
        </div>
      </div>
      <div v-show="isShowShare" class="draw-shareBox flex items-center">
        <div
          class="flex justify-center items-center"
          style="
            height: 7.45rem;
            width: 4.2rem;
            margin-top: 0.2rem;
            position: relative;
            border-radius: 0.14rem;
            overflow: hidden;
          "
        >
          <img
            src="../assets/icons/images/draw_sharebg.png"
            style="width: 4.2rem; height: 7.45rem"
            alt=""
          />
          <div
            class="flex justify-center"
            style="
              width: 3.8rem;
              position: absolute;
              padding: 0 0.2rem;
              overflow: hidden;
              max-height: 0.96rem;
              white-space: normal;
              text-align: center;
              font-size: 0.36rem;
              line-height: 0.48rem;
              top: 0.2rem;
              color: #fdd238;
            "
          >
            Convide amigos para ganhar mais giros e concorrer a 100 reais
          </div>
          <div
            v-if="userInfo?.id"
            style="
              color: #ccc;
              font-size: 0.14rem;
              position: absolute;
              bottom: 0.36rem;
              left: 0.1rem;
            "
          >
            <div class="flex items-center">
              <img
                style="
                  width: 0.28rem;
                  height: 0.28rem;
                  margin: 0 0.08rem 0 0;
                  border-radius: 50%;
                "
                :src="$store.state.config.user_avatar_image"
                alt=""
              />

              <div>{{ userInfo.user_name }}</div>
            </div>
            <div class="flex items-center" style="margin-top: 0.1rem">
              <div
                class="flex justify-center items-center"
                style="
                  width: 0.28rem;
                  height: 0.28rem;
                  margin: 0 0.08rem 0 0;
                  border-radius: 50%;
                  background-color: #7500b0;
                "
              >
                <svg-icon
                  style="
                    cursor: pointer;
                    width: 0.2rem;
                    height: 0.2rem;
                    color: #fff;
                  "
                  slot="left-icon"
                  classNameQita
                  icon-class="icon-share-logo"
                />
              </div>

              <div>
                Código de Convite
                <span style="color: #fedf58">{{ userInfo.id }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="!userInfo?.id"
            class="flex justify-center items-center"
            style="
              color: #ccc;
              font-size: 0.14rem;
              position: absolute;
              bottom: 0.36rem;
              left: 0.1rem;
            "
          >
            <div
              style="
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 0.2rem;
                margin: 0 0.08rem 0 0;
              "
            ></div>
            <div>web********************</div>
          </div>
          <div
            class="flex justify-center items-center"
            style="
              position: absolute;
              bottom: 0.14rem;
              right: 0.14rem;
              background: #fff;
              box-sizing: content-box;
              height: 0.94rem;
              width: 0.94rem;
              padding: 0.03rem;
              overflow: hidden;
            "
          >
            <canvas ref="qrcode_Canvas"></canvas>
          </div>
        </div>
        <div style="padding: 0.2rem 0.2rem 0; width: 6.5rem">
          <div
            class="flex justify-between items-center"
            style="color: #fff; padding-bottom: 0.2rem"
            v-if="userInfo?.id"
          >
            <p>Convidar amigos</p>
            <div class="flex justify-between items-center">
              <label style="margin-right: 0.1rem" >Meu código de convite</label>
              <p class="_invite-code_m5u13_66">{{ userInfo.id }}</p>
              <div style="margin: 0 0.1rem" @click="copyContent(userInfo.id)">
                <svg-icon
                  style="
                    cursor: pointer;
                    width: 0.24rem;
                    height: 0.24rem;
                    color: #fedf58;
                  "
                  icon-class="comm_icon_copy--svgSprite:all"
                />
              </div>
            </div>
          </div>
          <div class="flex justify-between items-center">
            <el-select v-model="urlVal">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div @click="copyContent(urlVal)">
              <svg-icon
                style="
                  cursor: pointer;
                  width: 0.24rem;
                  height: 0.24rem;
                  color: #fedf58;
                "
                icon-class="comm_icon_copy--svgSprite:all"
              />
            </div>
          </div>
          <div class="my-scrollbar-content">
            <div class="cX3I4wr8lagPbzMNAc5i">
              <div>
                <span class="zsbbPf1TFxnlj15CZdFo">
                  <svg-icon
                    className="imageWrap"
                    icon-class="icon_tg_share--svgSprite:all"
                  /> </span
                ><span>Partilhar</span>
              </div>
              <div>
                <span class="zsbbPf1TFxnlj15CZdFo">
                  <svg-icon
                    slot="left-icon"
                    classNameQita
                    className="imageWrap"
                    icon-class="icon-saveImage"
                  /> </span
                ><span>Salvar Foto</span>
              </div>
              <div>
                <img
                  data-groups-id="my-img-d88adec8-da36-445c-afc0-f255a2cec9b9"
                  @click="goToApp('telegram')"
                  src="../assets/kuaijiexiaz/img_tg.png"
                  alt="Telegram"
                  data-blur="0"
                  data-status="loaded"
                  class="goDRiiBsuEuXD3W1NphN"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Telegram</span>
              </div>
              <div>
                <img
                  data-groups-id="my-img-41ff331d-8644-4cb8-923d-f5cf0c500175"
                  @click="goToApp('facebook')"
                  src="../assets/kuaijiexiaz/img_facebook.png"
                  alt="Facebook"
                  data-blur="0"
                  data-status="loaded"
                  class="goDRiiBsuEuXD3W1NphN"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Facebook</span>
              </div>
              <div>
                <img
                  data-groups-id="my-img-3a08bcec-3ece-4370-9093-503f06ee7259"
                  @click="goToApp('whatsapp')"
                  src="../assets/kuaijiexiaz/img_wa.png"
                  alt="WhatsApp"
                  data-blur="0"
                  data-status="loaded"
                  class="goDRiiBsuEuXD3W1NphN"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>WhatsApp</span>
              </div>
              <div>
                <img
                  data-groups-id="my-img-49754333-e841-4188-9d3f-c56ab6a48d62"
                  @click="goToApp('instagram')"
                  src="../assets/kuaijiexiaz/1795519195972894722.png"
                  alt="Instagram"
                  class="goDRiiBsuEuXD3W1NphN"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Instagram</span>
              </div>
              <div>
                <img
                  src="../assets/kuaijiexiaz/img_line.png"
                  alt="Line"
                  data-blur="0"
                  data-status="loaded"
                  class="goDRiiBsuEuXD3W1NphN"
                  @click="goToApp('line')"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Line</span>
              </div>
              <div>
                <img
                  src="../assets/kuaijiexiaz/1795519414047723522.png"
                  alt="Twitter"
                  class="goDRiiBsuEuXD3W1NphN"
                  @click="goToApp('twitter')"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Twitter</span>
              </div>
              <div>
                <img
                  class="goDRiiBsuEuXD3W1NphN"
                  @click="goToApp('youtube')"
                  src="../assets/kuaijiexiaz/1795519529549303810.png"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Youtube</span>
              </div>
              <div>
                <img
                  data-groups-id="my-img-ec306707-cc70-4bf5-82a2-6f8e84a64732"
                  src="../assets/kuaijiexiaz/1795519631237173249.png"
                  class="goDRiiBsuEuXD3W1NphN"
                  @click="goToApp('tiktok')"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Tiktok</span>
              </div>
              <div>
                <img
                  data-groups-id="my-img-5d46d3a5-0368-4aaa-999e-c7f74cf067ce"
                  src="../assets/kuaijiexiaz/1795519724854632449.png"
                  class="goDRiiBsuEuXD3W1NphN"
                  @click="goToApp('kwai')"
                  style="width: 0.7rem; height: 0.7rem"
                /><span>Kwai</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showRecord"
        style="
          width: 6.5rem;
          height: 47dvh;
          color: #fff;
          background-color: #072e25;
          border-radius: 0.2rem;
          border: 1px solid #2e9368;
          padding: 0.2rem;
        "
      >
        <div
          style="text-align: center; padding-bottom: 0.2rem; font-size: 0.3rem"
        >
          Os meus subordinados
        </div>
        <div style="margin-bottom: 0.2rem">
          <div
            style="
              margin-bottom: 0.14rem;
              font-weight: 700;
              font-size: 0.22rem;
              line-height: 1.41;
            "
          >
            1、Condições válidas para subordinados
          </div>
          <div
            v-if="userInfo?.id"
            style="font-size: 0.22rem; line-height: 0.3rem"
          >
            <p class="_text_232sn_75">
              Recarga subordinada ≥
              {{ formatCurrency(String(invite_rule.recharge)) }}
            </p>
            <p class="_text_232sn_75">
              Apostas de nível inferior ≥
              {{ formatCurrency(String(invite_rule.bet)) }}
            </p>
          </div>
          <div v-else style="font-size: 0.22rem; line-height: 0.3rem">
            Faça login com sucesso durante o ciclo
          </div>
        </div>
        <div style="margin-bottom: 0.2rem">
          <div
            style="
              margin-bottom: 0.14rem;
              font-weight: 700;
              font-size: 0.22rem;
              line-height: 1.41;
            "
          >
            2、Meus subordinados
          </div>
        </div>
        <div
          class="flex justify-center items-center"
          style="
            height: 0.8rem;
            background-color: #013f25;
            border: 0.01rem solid #2e9368;
            text-align: center;
            border-radius: 0.1rem;
          "
        >
          <div class="ui-table__thead-item" style="width: 1.5rem">
            <span class="ui-table__thead-cell">Nome de Usuário</span>
          </div>
          <div class="ui-table__thead-item" style="width: 1.5rem">
            <span class="ui-table__thead-cell">Hora de registro</span>
          </div>
          <div class="ui-table__thead-item" style="width: 1.65rem">
            <span class="ui-table__thead-cell">Válido ou não</span>
          </div>
          <div class="ui-table__thead-item" style="width: 1.65rem">
            <span class="ui-table__thead-cell">Detalhes</span>
          </div>
        </div>
        <div class="tablelist">
          <div
            v-if="tableData.length > 0"
            v-for="item in tableData"
            class="flex justify-center items-center ui-table"
            style="height: 0.8rem; text-align: center"
          >
            <div class="ui-table__thead-item" style="width: 1.5rem">
              <span class="ui-table__thead-cell">{{ item.user_name }}</span>
            </div>
            <div class="ui-table__thead-item" style="width: 1.5rem">
              <span class="ui-table__thead-cell">{{ item.reg_time }}</span>
            </div>
            <div class="ui-table__thead-item" style="width: 1.65rem">
              <span
                class="ui-table__thead-cell"
                :style="{ color: item.valid == 1 ? '#04be02' : 'red' }"
                >{{ item.valid == 1 ? 'Válido' : 'Inválido' }}</span
              >
            </div>
            <div
              class="ui-table__thead-item"
              style="width: 1.65rem; color: #fedf58"
            >
              <span class="ui-table__thead-cell" @click="showDetail(item)"
                >Visualizar</span
              >
            </div>
          </div>
          <div v-if="tableData.length === 0">
            <van-empty
              image-size="2.1rem"
              class="custom-image"
              :image="img_none_sj"
              :description="$t('description')"
            />
          </div>
        </div>
      </div>
      <div
        class="flex items-center"
        v-if="showReceber"
        style="
          width: 6.5rem;
          height: 55dvh;
          color: #fff;
          padding: 0.2rem;
          position: relative;
          flex-direction: column;
        "
      >
        <div style="font-size: 0.3rem; font-weight: 600">Bônus grátis</div>
        <div class="flex justify-center items-center" style="color: #fedf58">
          <svg-icon
            slot="left-icon"
            style="width: 0.42rem; height: 0.42rem"
            classNameQita
            icon-class="icon-draw-money-icon"
          />
          <span
            style="
              margin-left: 0.1rem;
              font-size: 0.48rem;
              line-height: 0.72rem;
              font-weight: 700;
            "
            >{{ formatCurrency(String(bonusMoney)) }}</span
          >
        </div>
        <div style="height: 0.23rem; width: 4.5rem; position: relative">
          <el-progress
            :text-inside="true"
            :percentage="bonusMoney"
            color="#04BE02"
          >
          </el-progress>
          <span
            style="
              font-size: 0.2rem;
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              margin: 0 auto;
              text-align: center;
              line-height: 0.23rem;
            "
            >Ainda há
            {{
              formatCurrency(String((100 * 1000 - bonusMoney * 1000) / 1000))
            }}
            para coletar</span
          >
        </div>
        <div
          style="
            width: 5.5rem;
            height: 5.5rem;
            position: relative;
            margin-top: -0.6rem;
          "
        >
          <svg-icon
            slot="left-icon"
            style="
              width: 5.5rem;
              height: 5.5rem;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 101;
            "
            classNameQita
            icon-class="icon-receberbox"
          />
          <img
            class="rotate-element"
            style="
              width: 5.5rem;
              height: 5.5rem;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 100;
            "
            src="../assets/icons/images/receberbox-gh.png"
            alt=""
          />
          <img
            style="
              width: 5.5rem;
              height: 5.5rem;
              position: absolute;
              left: -0.6rem;
              top: 0;
            "
            src="../assets/icons/images/receberbox-light.png"
            alt=""
          />
          <img
            style="
              width: 3rem;
              height: 3rem;
              position: absolute;
              right: 0.1rem;
              bottom: 0.7rem;
            "
            src="../assets/icons/images/receberbox-light.png"
            alt=""
          />
        </div>
        <div class="receberbox-sharebtn" @click="isShowShare = true">
          Convidar amigos, Bônus de vitória
        </div>
        <div
          class="flex justify-center items-center"
          style="
            width: 0.46rem;
            height: 0.46rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            z-index: 200;
            cursor: pointer;
          "
          @click="showReceber = false"
        >
          <img
            style="width: 0.46rem; height: 0.46rem; z-index: 200"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
            alt=""
          />
        </div>
      </div>
      <div
        class="flex items-center"
        v-if="showBonus"
        style="
          width: 6.5rem;
          height: 50dvh;
          color: #fff;
          padding: 0.2rem;
          position: relative;
          flex-direction: column;
          margin-top: -1.5rem;
        "
      >
        <div style="font-size: 0.3rem; width: 3.3rem; text-align: center">
          Parabéns, você ganhou o bônus
        </div>
        <div class="flex justify-center items-center" style="color: #fedf58">
          <svg-icon
            slot="left-icon"
            style="width: 0.42rem; height: 0.42rem"
            classNameQita
            icon-class="icon-draw-money-icon"
          />
          <span
            style="
              margin-left: 0.1rem;
              font-size: 0.48rem;
              line-height: 0.72rem;
              font-weight: 700;
            "
            >{{ temu_bonusMoney }}</span
          >
        </div>
        <div
          style="
            width: 6rem;
            height: 6rem;
            position: relative;
            margin-top: -1rem;
            margin-right: 0.2rem;
          "
        >
          <svg-icon
            slot="left-icon"
            style="
              width: 6rem;
              height: 6rem;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 200;
            "
            classNameQita
            icon-class="icon-receberbox"
          />
          <img
            style="
              width: 5.5rem;
              height: 5.5rem;
              position: absolute;
              left: 0;
              right: 0;
              top: 0.5rem;
              margin: 0 auto;
              z-index: 100;
            "
            src="../assets/icons/images/receberbox-gh.png"
            alt=""
          />
          <img
            style="
              width: 5.5rem;
              height: 5.5rem;
              position: absolute;
              left: -0.4rem;
              top: 0.2rem;
              z-index: 100;
            "
            src="../assets/icons/images/receberbox-light.png"
            alt=""
          />
          <img
            style="
              width: 3.5rem;
              height: 3.5rem;
              position: absolute;
              right: 0.1rem;
              bottom: 0.7rem;
              z-index: 100;
            "
            src="../assets/icons/images/receberbox-light.png"
            alt=""
          />
        </div>
      </div>
      <div
        v-if="isShowShare"
        class="flex justify-center items-center"
        style="
          width: 0.65rem;
          height: 0.65rem;
          position: absolute;
          bottom: 0.3rem;
        "
        @click="isShowShare = false"
      >
        <img
          style="width: 0.65rem; height: 0.65rem"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
      <div
        v-if="showRecord"
        class="flex justify-center items-center"
        style="
          width: 0.65rem;
          height: 0.65rem;
          position: absolute;
          bottom: 18dvh;
        "
        @click="showRecord = false"
      >
        <img
          style="width: 0.65rem; height: 0.65rem"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAAilBMVEUAAAD////e5Orv8vXe5Or////e5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Ore5Or////////h5+z8/f7z9ffm6/Dp7fHt8PT5+vv2+PrCEzcDAAAAJXRSTlMAYJYggoAJR6DVzbyRfHYuimpXKBlePTURrlDbxOm27OJwZaif1OMsUAAABGNJREFUWMPdmdtiojAQhlNAOSOoeK6tugRy4P1fb0lCO26DDRiv9r8Twsfkz0wSA/ovtVh6tzj8fP/4eP+M4iBdrpC93GtwJJQ1La+leNswisOgXNtQd9czpg2vNPGG4v1y/iR2lWDaVo9Ud2xv/YyxDmnqnsG77hOCOxFhC/+6znDuTsSuHdx89ZrgU5CW/nbluqutX6ZBJP1RYeN8kiEZZv2DJMr9nfbaZRL2/alZdJ3ignyIU5xvHzXaOJipVsQZaXWBG4UNi99zJuvR7LQcw00Il63xxdw2VTG02DO3dahqmuxG1Y8jw6iJY2g4V1wWH9BIFZEMmjoGLlPv302oI4eayYqLczRJKomoY/CX4wxNVI4F+bHPDpHcAk2Wp8gPcuOChQ/AnURWzx4GByEUiYNT9JQS0ds2HjSiEb1JnoDC+LABmzMCN55SIALDpVb4wn4eWSw4G0k4aR4x8b4rslAq+ky9HyOHlRFWujUiM34ELK9JI2zM0EJewyUbJVrIHuuufNpvQsT40QKB5IVsoOVsNnMRGnEDQuYh/F5S0QV9uX2rhN7QmBuQAwTWyX33osbRw6qU3nSukh5z3Hak/J/iIBut1awC8hC3mmmPlLQfLHDiiAbBQNa51R99CcL1nReOcCIZBgNZ50LEoHPHYl9pIOZLekCDHgNZ54LHoIx1QZ7758VQalUHECBrl3RtCSTYgYh5DSET2cgFkxcQfYDMZANX6dR2vi6/x455aAR5BBcFMHpiIGmJRpDNXDXt9MUW8c4VHxnII7mooN9pEXJZdwaymQvV1qoF6hPG0UQ2c5EPOfbRgfEKmcnANYHDEWAgA9cMBivswboVRzF4W3srYPD4SUs3+8G7iqw4qwJpoUDs0y2VEwQUYfqSAgEavONVJR3L/oPd0asmIVib5Jpd491rps3F3USPjjWkhe1EX1C5sQe/m/w1S9PtfnIvhcmh9WIKFm9grwnzm93yf5AWaxsj6w0LbNagDOt3yy0W9H3z75pNC+tNob7PduS+1mYbCwGy7D6tZRcuA/vrP7C/Nt/IGVTHXfrxI7LTSgacD/zhSezADvz1+nnRt+EWIjj2M7iF6EZztuC6IRd2zjXjqTx+sTCCQQJoRVOR9GkuqWTR6fJxLWwun+OmwmAeDuamR8S96PDUwMlDIVz8ckjSxk+Qr5hrxzOa/+1pshsXzH8feddpBBlfph67cdNpx0KSOZ5SgnOH1JI7R0ZyTZ3FWK6/Z5Xk7kzntrJdg7OxNvSHsfORPavpmOwoI1rD8bFJHm7l2TTZG+akZUz4pO4dYlbLB0hUrB96loVEBlDTYDN6oBPlXMUp3hergTG+xJjxSoXrTTrpupH2+8tPeEuXW3c37964c7eltz8SJu7KTpnzRzewqZTkFyHcS34TqnqsNgwjM5So7irVUvCbMwzmTtTCw6LTuuqWkShzkYV874T774TwpZDgON0ia7mHNDgdu++anT7ej3GQ+Wv0H+ov9UMLyPmx8boAAAAASUVORK5CYII="
          alt=""
        />
      </div>
    </div>

    <div
      v-if="showbox"
      class="flex justify-center items-center"
      style="
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        position: relative;
        z-index: 100;
      "
    >
      <div style="width: 6rem; height: 65dvh; color: #fedf58">
        <div class="flex justify-center items-center">
          <svg-icon
            slot="left-icon"
            style="width: 0.55rem; height: 0.55rem"
            classNameQita
            icon-class="icon-draw-title"
          />
          <span style="font-size: 0.4rem; margin: 0 0.2rem">Sorteio</span>
          <svg-icon
            slot="left-icon"
            style="width: 0.55rem; height: 0.55rem; transform: rotate(-180deg)"
            classNameQita
            icon-class="icon-draw-title"
          />
        </div>
        <div
          v-if="clickNum == 0"
          style="
            font-size: 0.37rem;
            font-weight: 700;
            width: 100%;
            text-align: center;
            margin-top: 0.1rem;
          "
        >
          <span style="color: #fff">Escolha um prêmio de até</span
          ><span>100,00</span>
        </div>
        <div
          v-else
          style="
            font-size: 0.37rem;
            font-weight: 700;
            width: 100%;
            text-align: center;
            margin-top: 0.1rem;
          "
        >
          <span style="color: #fff">Parabéns por ganhar o</span
          ><span style="margin-left: 0.1rem">{{
            formatCurrency(String(bonusMoney))
          }}</span>
        </div>
        <div class="draw-box">
          <div v-for="item in 4">
            <div
              @click="choosebox(item)"
              class="draw-item"
              v-if="clickNum !== item"
            >
              <img
                src="../assets/icons/images/draw-box.png"
                alt=""
                style="width: 1.95rem"
              />
              <img
                v-if="item == showNum && clickNum == 0"
                class="box-hand"
                src="../assets/icons/images/draw-hand.png"
                alt=""
                style="
                  width: 0.71rem;
                  position: absolute;
                  bottom: 0.94rem;
                  right: 0.88rem;
                  z-index: 3;
                "
              />
              <div
                v-if="clickNum == 0"
                style="
                  font-size: 0.26rem;
                  text-align: center;
                  color: #fff;
                  position: absolute;
                  bottom: 0;
                  width: 3rem;
                "
              >
                Ativar
              </div>
              <div
                v-else
                style="
                  font-size: 0.26rem;
                  text-align: center;
                  color: #fff;
                  position: absolute;
                  bottom: 0;
                  width: 3rem;
                "
              >
                {{ firstList[item - 1] }}
              </div>
            </div>
            <div v-else class="draw-item">
              <img
                src="../assets/icons/images/draw-gh.png"
                alt=""
                style="width: 3rem; position: absolute; top: 0rem"
              />
              <img
                src="../assets/icons/images/draw-topbox.png"
                alt=""
                style="
                  width: 1.95rem;
                  position: absolute;
                  top: 0.15rem;
                  right: 0.44rem;
                "
              />
              <img
                src="../assets/icons/images/draw-bottombox.png"
                alt=""
                style="width: 1.95rem; position: absolute; top: 1.4rem"
              />
              <img
                src="../assets/icons/images/draw-boxmoney.png"
                alt=""
                style="width: 1.6rem; position: absolute; top: 1.23rem"
              />
              <div
                class="flex justify-center items-center"
                style="
                  position: absolute;
                  bottom: 0;
                  padding: 0.08rem 0.2rem;
                  background-color: #072e25;
                  border-radius: 1rem;
                  border: 1px solid #2e9368;
                "
              >
                <svg-icon
                  slot="left-icon"
                  style="width: 0.4rem; height: 0.4rem"
                  classNameQita
                  icon-class="icon-draw-money-icon"
                />
                <span style="font-size: 0.3rem; margin-left: 0.1rem">{{
                  formatCurrency(String(bonusMoney))
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { mapState } from 'vuex';
import { Toast } from 'vant';
import {
  turntablePDD,
  signInPDD,
  startPDDTurntable
} from '@/apis/modules/home.js';
import { shareInvite } from '@/apis/modules/share.js';
import { userInfo } from '../apis/modules/home';
export default {
  computed: {
    ...mapState(['popList', 'userInfo'])
  },
  props: {},
  data() {
    return {
      tableData: [],
      records: [],
      firstList: [],
      urlVal: window.location.origin,
      options: [
        {
          label: window.location.origin,
          value: window.location.origin
        }
      ],
      shareInfo: {},
      origin: '',
      urlSuffix: '',
      isShowShare: false,
      lotteryChances: 0,
      startLoading: false,
      bonusLoading: false,
      steptwo: false,
      showTemuOut: false,
      showNum: 1,
      clickNum: 0,
      bonusMoney: '0,00',
      temu_bonusMoney: '0,00',
      showbox: false, // 首次抽奖
      showRecord: false, // 下级数据
      showReceber: false, // 中奖数据
      showBonus: false, // 中奖动画
      rotate: 0,
      register_prize: [
        {
          name: '0-11,11',
          icon: require('../assets/icons/images/draw_bonus2.png')
        },
        {
          name: '0-33,33',
          icon: require('../assets/icons/images/draw_bonus3.png')
        },
        {
          name: '0-55,55',
          icon: require('../assets/icons/images/draw_bonus4.png')
        },
        {
          name: '0-77,77',
          icon: require('../assets/icons/images/draw_bonus5.png')
        },
        {
          name: '0-99,99',
          icon: require('../assets/icons/images/draw_bonus6.png')
        },
        {
          name: '0-100',
          icon: require('../assets/icons/images/draw_bonus1.png')
        }
      ],
      mission: {
        online: false,
        login: true
      },
      countdown: 0,
      isFirstClose: true,
      showDetails: false,
      details: {},
      invite_rule: {},
      showInstructions: false,
      winningRecord: []
    };
  },
  mounted() {
    this.initWinRecodes();
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setHours(0, 0, 0, 0); // 设置时间为明天早上11点
    tomorrow.setDate(now.getDate() + 1); // 将日期设置为明天
    this.countdown = tomorrow.getTime() - now.getTime(); // 获取两个时间之间的毫秒数差异
    this.turntablePDD();
    this.runNum();
    this.changeshowtemuout();
    this.getUserInfo();
    if (this.userInfo.can_share) {
      this.origin = window.location.origin;
      this.urlSuffix = '/?' + this.$store.state.config.invite_mark + '=';
      let subSuffix = '';
      if (this.$store.state.config.invite_link_type == 'long') {
        if (this.$store.state.config.currency == 'R$') {
          subSuffix = '&currency=BRL&type=2';
        } else if (this.$store.state.config.currency == '$') {
          subSuffix = '&currency=USD&type=2';
        } else if (this.$store.state.config.currency == 'C$') {
          subSuffix = '&currency=COP&type=2';
        } else if (this.$store.state.config.currency == '₹') {
          subSuffix = '&currency=INR&type=2';
        } else if (this.$store.state.config.currency == '¢') {
          subSuffix = '&currency=MYR&type=2';
        } else if (this.$store.state.config.currency == 'M$') {
          subSuffix = '&currency=MXN&type=2';
        }
      }
      this.urlSuffix += this.userInfo.id + (['3.4', '3.8','3.8_2'].includes(this.$store.state.config.ui_version) ? '' : subSuffix);
      this.options[0].value = this.origin + this.urlSuffix;
      this.options[0].label = this.origin + this.urlSuffix;
      this.urlVal = this.origin + this.urlSuffix;
    }
    this.generateQRCode();
  },
  methods: {
    getUserInfo() {
      if(this.$store.state.config.goto_bind_ws && this.userInfo.id && !this.userInfo.bind_ws && this.$store.state.config.bind_ws){
        userInfo({}).then(({ data,code }) => {
          if(code == 0){
            this.$store.state.config.goto_bind_ws = false;
            this.$store.commit('userInfo', data);
          }
        });
      }
    },
    showRecordBox() {
      this.showRecord = true;
      this.shareInvite();
    },
    initWinRecodes() {
      for (let index = 0; index < 20; index++) {
        const obj = {
          userid:
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            '****' +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)) +
            String(Math.floor(Math.random() * 10)),
          money: this.formatCurrency((Math.floor(Math.random() * (9900 - 9300 + 1)) + 9300)/100)
        };
        this.winningRecord.push(obj);
      }
    },
    showDetail(obj) {
      this.details = obj;
      this.showDetails = true;
    },
    shareInvite() {
      shareInvite({
        source: 1
      }).then(({ data }) => {
        this.tableData = data;
      });
    },
    closeBox() {
      if (this.isFirstClose) {
        this.isFirstClose = false;
        this.showReceber = true;
      } else {
        this.$store.state.isShowWheelSpinEvent = false;
      }
    },
    signInPDD() {
      signInPDD({}).then(({ code, data = {}, msg }) => {
        if (code == 0) {
          this.turntablePDD();
        }
      });
    },
    turntablePDD() {
      turntablePDD({}).then(({ code, data = {}, msg }) => {
        if (data.now_bonus == 0) {
          this.showbox = true;
        }
        this.lotteryChances = data.surplus_lottery;
        this.records = data.records;
        this.bonusMoney = data.now_bonus;
        this.mission = data.mission;
        this.invite_rule = data.invite_rule;
      });
    },
    goToApp(name) {
      let shareUrl = this.origin + this.urlSuffix;
      shareUrl = shareUrl || window.location.origin;
      if (shareUrl) this.copyContent(shareUrl);
      if (name == 'telegram') {
        window.location.href = 'tg://';
      } else if (name == 'facebook') {
        window.location.href = 'facebook://';
      } else if (name == 'whatsapp') {
        window.location.href = 'whatsapp://';
      } else if (name == 'instagram') {
        window.location.href = 'instagram://';
      } else if (name == 'line') {
        window.location.href = 'line://';
      } else if (name == 'twitter') {
        window.location.href = 'twitter://';
      } else if (name == 'youtube') {
        window.location.href = 'youtube://';
      } else if (name == 'tiktok') {
        window.location.href = 'tiktok://';
      } else if (name == 'kwai') {
        window.location.href = 'kwai://';
      }
    },
    receber() {
      if (!this.userInfo.id) {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', ['isRecordType', 0]);
        return;
      }
      if (this.userInfo.balance.length !== 0) {
        this.$router.push({
          name: this.userInfo.set_withdraw_password ? 'withdraw' : 'security'
        });
      } else {
        if (this.bonusMoney >= 100) {
          startPDDTurntable({ type: 2 }).then(({ code, data = {}, msg }) => {
            this.temu_bonusMoney = data.bonus;
            this.showBonus = true;
            setTimeout(() => {
              this.showBonus = false;
              this.turntablePDD();
            }, 3000);
          });
        } else {
          this.showReceber = true;
        }
      }
    },
    generateQRCode() {
      if (!this.userInfo.can_share) return;
      const canvas = this.$refs.qrcode_Canvas;
      QRCode.toCanvas(
        canvas,
        `${this.origin}${this.urlSuffix}`,
        {
          width: 80,
          height: 80,
          toSJISFunc: QRCode.toSJIS
        },
        error => {
          //if (error) console.error(error, 'QRCode');
        }
      );
    },
    changeshowtemuout() {
      setTimeout(() => {
        this.showTemuOut = !this.showTemuOut;
        this.changeshowtemuout();
      }, 1500);
    },
    async handleStart() {
      if (
        this.startLoading ||
        this.lotteryChances == 0 ||
        this.bonusMoney >= 100
      ) {
        return;
      }
      if (!this.userInfo.id) {
        this.$store.commit('isRecord');
        this.$store.commit('publicFun', ['isRecordType', 0]);
        return;
      }
      
      // 需要绑定WS
      let needBind = false
      if(this.$store.state.config.bind_ws){
        let isStop = false,msg = '';
        if(this.userInfo.bind_ws){
          // 是否持续绑定中
          if(this.$store.state.config.check_bind){
            try{
              this.$store.commit('sLoading', true);
              const response = await fetch(this.$store.state.config.check_bind+'?user_id='+this.userInfo.id+'&domain='+window.location.hostname);
              // 检查 HTTP 响应状态 (fetch 不会自动把 404/500 变成错误)
              if (!response.ok) {
                isStop = true,msg = 'Por favor, tente novamente.';
              }else{
                const resData = await response.text();
                if(resData == 'Proxy-Retry'){
                  isStop = true,msg = 'Por favor, tente novamente.';
                }else if(resData == 'Not-Found' || resData == 'flase'){
                  needBind = true,msg = 'Por favor, vincule sua conta WhatsApp primeiro para garantir a segurança da sua conta.';
                }
              }
            }catch(error){
              isStop = true,msg = 'Por favor, tente novamente.';
            }finally{
              this.$store.commit('sLoading', false);
            }
          }
        }else{
          needBind = true,msg = 'Por favor, vincule sua conta WhatsApp primeiro para garantir a segurança da sua conta.';
        }
        // 需要提示信息
        if(msg){
          Toast.fail({message: this.myLineBreaks(msg),duration: 2000});
          if(isStop)return;
        }
      }

      // 需要绑定
      if(needBind){
        this.$store.state.config.goto_bind_ws = true;
        this.$router.push({
          name: 'webviewCommon',
          params: {
            url: this.$store.state.config.bind_ws+'/'+window.location.hostname+'/'+this.userInfo.id
          }
        });
        return;
      }else{
        this.startTurntable();
      }
    },
    startTurntable(){
      startPDDTurntable({ type: 1 }).then(({ code, data = {}, msg }) => {
        this.temu_bonusMoney = data.bonus;
      });
      this.startLoading = true;
      let deg = Math.floor(Math.random() * (20 - 15) + 5) * 360;
      this.rotate += deg - (this.rotate % 360);
      setTimeout(() => {
        this.startLoading = false;
        this.bonusLoading = true;
        setTimeout(() => {
          this.bonusLoading = false;
          this.showBonus = true;
          setTimeout(() => {
            this.showBonus = false;
            this.turntablePDD();
          }, 3000);
        }, 1000);
      }, 5100);
    },
    choosebox(val) {
      if (this.clickNum == 0) {
        startPDDTurntable({}).then(({ code, data = {}, msg }) => {
          this.clickNum = val;
          this.bonusMoney = data.bonus;
          if (data?.list.length) {
            this.firstList = data.list;
            const temp = this.firstList[data.order];
            this.firstList.splice(data.order, 1);
            this.firstList.splice(val - 1, 0, temp);
          }
        });
        setTimeout(() => {
          this.showbox = false;
          this.turntablePDD();
        }, 3000);
      }
    },
    runNum() {
      if (this.showNum == 4) {
        this.showNum = 1;
      } else {
        this.showNum += 1;
      }
      setTimeout(() => {
        this.runNum();
      }, 1000);
    }
  }
};
</script>
<style scoped>
/* .el-select-dropdown {
  border-color: #2e9368 !important;
  background-color: #072e25 !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  color: #fedf58 !important;
  background-color: #072e25 !important;
}
.el-select-dropdown__item.selected {
  color: #fedf58 !important;
}
.el-select-dropdown__item {
  color: #809f92;
} */
.popper__arrow {
  display: none !important;
}
.el-popper {
  margin-top: 0 !important;
}
.instructions-title {
  position: relative;
  display: inline-block;
  left: -0.28rem;
  height: 0.62rem;
  margin-bottom: 0.2rem;
  max-width: 100%;
}
.instructions-title::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0.08rem;
  height: 0.1rem;
  background-color: #fedf58;
  border-bottom-left-radius: 0.06rem;
}
.instructions-title::after {
  content: '';
  position: absolute;
  top: 0.24rem;
  right: -0.28rem;
  width: 0.08rem;
  height: 0.08rem;
  background-color: #fedf58;
  border-radius: 50%;
  z-index: 1;
}

.arrow_right {
  position: absolute;
  top: 0;
  right: -0.26rem;
  width: 0.28rem;
  height: 0.56rem;
  overflow: hidden;
  z-index: 0;
}
.arrow_right::after {
  content: '';
  position: absolute;
  top: -0.04rem;
  left: 0;
  border: 0.32rem solid transparent;
  border-left-color: #fedf58;
}

.numchange {
  margin-top: -0.5rem;
  animation: 0.5s rowupone linear infinite normal;
  animation-iteration-count: 1;
}
.numchange2 {
  animation: 0.5s rowuptwo linear infinite normal;
  animation-iteration-count: 1;
}
@keyframes rowupone {
  0% {
    transform: translateY(0.5rem);
  }
  25% {
    transform: translateY(0.375rem);
  }
  50% {
    transform: translateY(0.25rem);
  }
  75% {
    transform: translateY(0.125rem);
  }
  100% {
    transform: translateY(0rem);
  }
}
@keyframes rowuptwo {
  0% {
    transform: translateY(0.5rem);
  }
  25% {
    transform: translateY(0.375rem);
  }
  50% {
    transform: translateY(0.25rem);
  }
  75% {
    transform: translateY(0.125rem);
  }
  100% {
    transform: translateY(0rem);
  }
}
.receberbox-sharebtn {
  background: linear-gradient(180deg, #5ab6ff, #0985e9);
  box-shadow: 0 0.04rem 0.1rem rgba(76, 15, 15, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  margin-top: -0.3rem;
  width: 3.6rem;
  height: 0.64rem;
  border-radius: 0.35rem;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
  cursor: pointer;
  z-index: 200;
}
.rotate-element {
  animation: rotateAnimation 20s linear infinite; /* 持续时间2秒，线性速度，无限循环 */
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

:deep(.el-progress) {
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.el-progress-bar__outer) {
  background-color: rgba(0, 0, 0, 0.4) !important;
  height: 0.23rem !important;
}
:deep(.van-empty__description) {
  color: #809f92 !important;
  font-size: 0.26rem;
}
.tablelist {
  width: 100%;
  height: 3.45rem;
  overflow-y: scroll;
  .ui-table:nth-child(even) {
    background-color: #013f25;
  }
  .ui-table:nth-child(odd) {
    background-color: transparent;
  }
}
.ui-table__thead-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.1rem;
  font-size: 0.24rem;
  line-height: 0.3rem;
  word-break: break-word;
  .ui-table__thead-cell {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
:deep(.el-select) {
  width: calc(100% - 0.5rem);
}
:deep(.el-input__inner) {
  background-color: #072e25;
  border-color: #2e9368;
  color: #809f92;
  border-radius: 0.1rem !important;
}
:deep(.el-input__inner:focus) {
  border-color: #2e9368 !important;
}
:deep(.el-input__inner:hover) {
  border-color: #2e9368 !important;
}
:deep(.el-select .el-input.is-focus .el-input__inner) {
  border-color: #fedf58;
  color: #809f92;
}
:deep(.el-select .el-input.is-focus .el-input__inner:focus) {
  border-color: #fedf58 !important;
}
:deep(.el-select .el-input.is-focus .el-input__inner:hover) {
  border-color: #fedf58 !important;
}
.cX3I4wr8lagPbzMNAc5i {
  -ms-flex-align: start;
  align-items: flex-start;
  display: -ms-flexbox;
  display: flex;
  min-height: 1.35rem;
  padding-bottom: 0.06rem;
  padding-top: 0.2rem;
}

.cX3I4wr8lagPbzMNAc5i .my-scrollbar-bar.my-scrollbar-horizontal {
  bottom: 0;
}

.cX3I4wr8lagPbzMNAc5i > div {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0.95rem;
}

.cX3I4wr8lagPbzMNAc5i > div:not(:last-child) {
  margin-right: 0.1rem;
}

.cX3I4wr8lagPbzMNAc5i > div > img {
  border-radius: 50%;
}

.my-scrollbar-content {
  margin-top: 0.2rem;
  width: 100%;
  overflow-y: scroll;
}

.cX3I4wr8lagPbzMNAc5i > div > span {
  word-wrap: break-word;
  display: inline-block;
  font-size: 0.22rem;
  line-height: 1.15;
  max-width: 1.1rem;
  padding-top: 0.1rem;
  text-align: center;
  color: var(--theme-text-color);
}

.cX3I4wr8lagPbzMNAc5i .zsbbPf1TFxnlj15CZdFo {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  border-radius: 50%;
  color: var(--theme-primary-font-color);
  background-color: #fff;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.36rem;
  height: 0.7rem;
  justify-content: center;
  padding: 0;
  width: 0.7rem;
}

.box-item {
  background-color: #013f25;
  min-height: 0.6rem;
  margin: 0px;
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.my-records {
  .my-records-item {
    background-color: #013f25;
    margin: 0px;
    padding: 0.1rem 0.2rem;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
    height: 0.4rem;
    .my-records-item-info {
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      white-space: nowrap; /* 防止文本换行 */
      overflow: hidden; /* 隐藏溢出的文本 */
      text-overflow: ellipsis; /* 显示省略号 */
      text-align: left;
    }
  }
  .my-records-item:nth-child(odd) {
    background-color: transparent;
  }
}
.draw-shareBox {
  width: 6.9rem;
  /* height: 80dvh; */
  background-image: url(../assets/icons/images/draw_mainbox_bg.png);
  background-color: #072e25;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center 0.2rem;
  font-size: 0.24rem;
  border-radius: 0.2rem;
  border: 1px solid #2e9368;
  padding: 0.2rem 0;
  margin-top: -0.5rem;
  flex-direction: column;
  position: absolute;
  z-index: 300;
}
.draw-mainbox {
  overflow-y: scroll;
  background-image: url('../assets/icons/images/draw_mainbox_bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
  width: calc(100% - 0.4rem);
  height: calc(78dvh - 0.4rem - 0.2rem);
  background-position: center -0.9rem;
  padding: 0 0.2rem;
  .temu-panel {
    width: 100%;
    @keyframes drawnfloat-s1mafayd-2768b8c4 {
      0% {
        top: 15%;
      }
      50% {
        top: calc(15% + 2rem);
      }
      100% {
        top: 15%;
      }
    }
    .temu-box {
      width: 6.1rem;
      height: 6.1rem;
      position: relative;
      left: 0;
      right: 0;
      margin: 0 auto;
      .point {
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url('../assets/icons/images/draw_point.png');
        background-repeat: no-repeat !important;
        background-size: contain !important;
        width: 2.48rem;
        height: 2.48rem;
        top: calc(50% - 1.24rem);
        position: absolute;
        left: 0;
        right: 0;
        margin: -0.14rem auto;
        cursor: pointer;
      }
      .turntable-main {
        width: 6.1rem;
        height: 6.1rem;
        position: absolute;
        top: -0.14rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-position: center;
        .turntable-main-item {
          width: 1.24rem;
          height: 4.9rem;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .turntable-main1 {
        background-size: 79%;
        background-image: url('../assets/icons/images/draw_temubox.png');
        transition: transform 5s ease-in-out, -webkit-transform 5s ease-in-out;
        background-repeat: no-repeat !important;
        background-position: center;
      }
      .turntable-main2 {
        background-size: 100%;
        background-image: url('../assets/icons/images/draw_temuout1.png');
        background-repeat: no-repeat !important;
        background-position: center;
      }
      .turntable-main3 {
        background-size: 100%;
        background-image: url('../assets/icons/images/draw_temuout2.png');
        background-repeat: no-repeat !important;
        background-position: center;
      }
    }
  }
}
.notice-swipe {
  height: 0.3rem;
  line-height: 0.3rem;
}
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
.draw-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.5rem;
  .draw-item {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 3rem;
    height: 3.5rem;
  }
}
.box-hand {
  animation: heartBeat 1s infinite;
}
</style>
